export const en = {
    'NumberDefectIds.MUST_BE_NOT_OLDER': 'Select a different period and try again',
    'NumberDefectIds.MUST_BE_NOT_OLDER-TITLE': 'Unable to display statistics',
    bannerAimingFailed: 'Something went wrong. Try to preview again later.',
    bannerAimingSuccessful: 'The ad has been successfully targeted. You now have 10 minutes to preview the ad.',
    'cancel-survey': 'Cancel Brand Lift analysis?',
    'client-campaigns': 'Client campaigns',
    'could-not-cancel-survey': 'Error canceling analysis',
    'failed-to-update-data': "Couldn't update data. Showing previous values",
    'fetch-moderation-reject-reasons-error': 'Unable to get rejection reasons. Please try again',
    'link-message-groups': 'View',
    'mass-actions-server-error': 'An error occurred. Please refresh the page.',
    'my-campaigns': 'My campaigns',
    operationError: 'An error occurred while copying',
    'phrase-1': 'keywords',
    'phrase-2': 'keywords',
    'phrase-5': 'keywords',
    'popup-save-success': 'Changes saved',
    'search-and-replace-success': 'Replaced in {updatedTotalCount} out of {selectedCount} {phraseWord}'
};
